var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcGolpesespalda(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29 35.5H18.5C17.5 33.5 18 32.5 19.5 29C20.7 26.2 19.3333 23.1667 18.5 22C17.7 13.2 22.5 8.66667 25 7.5C24.6 6.7 24.8333 4.5 25 3.5H33C33.5 4 31.5 7.5 31 8.5C30.5 9.5 29 9 28 9C27 9 25.5 11 27 12.5C28.5 14 29 20 28 24.5C27.2 28.1 28.3333 33.3333 29 35.5Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.1514 3.57532C24.9533 4.16803 24.8757 5.05516 25.078 5.86611C25.4561 7.38598 26.9672 8.8839 29.1085 9.50115C30.934 10.0267 32.8925 5.63238 32.8925 3.57532",
    stroke: "#228C80",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1417 10.0404C20.3562 11.3783 17.0773 15.3586 18.246 20.5764C19.7069 27.0986 25.0635 9.03702 22.1417 10.0404Z",
    fill: "#F9839A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25.2941 6.48462C24.7165 7.98383 18.7234 10.4089 18.2871 16.3257C17.8937 21.6485 19.6971 23.8605 19.5295 26.5891C19.3619 29.3163 17.884 30.3816 17.884 33.0108C17.884 34.6391 18.3882 35.5753 18.3882 35.5753",
    stroke: "#228C80",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M28.0045 9.08264C28.0045 9.08264 26.2607 9.81482 26.1236 11.0661C26.0197 12.0191 28.6444 15.259 28.5946 17.8881C28.5599 19.6727 28.2469 23.1308 28.0502 25.1685",
    stroke: "#228C80",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M28.9631 35.5754C28.7622 27.28 27.2165 26.828 26.6791 24.7465C26.1417 22.6649 26.7636 20.4735 26.1514 15.6827C25.8467 13.299 23.8591 12.3499 23.8591 12.3499",
    stroke: "#228C80",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0739 15.9189C21.6154 19.8936 22.4506 22.227 23.2899 24.8406C24.1293 27.4542 23.157 27.7939 24.2304 30.9447C24.9022 32.9165 26.1224 35.5753 26.1224 35.5753",
    stroke: "#228C80",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 17.5L7 21L12 24L13.5 22.5L17.5 13H11.5L8.5 17.5Z",
    fill: "#F5FBFA"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5364 13.8183L12.9095 11.5737C13.1643 11.1574 13.095 10.5945 12.7155 10.2939C12.28 9.94956 11.6624 10.0711 11.3774 10.5377L8.6158 15.052C8.33782 15.5064 8.11726 15.996 7.96041 16.5079C7.74335 17.2168 7.65022 17.9602 7.68593 18.7029L7.73495 19.7245L6.84009 21.1869",
    fill: "#F5FBFA"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5364 13.8183L12.9095 11.5737C13.1643 11.1574 13.095 10.5945 12.7155 10.2939C12.28 9.94956 11.6624 10.0711 11.3774 10.5377L8.6158 15.052C8.33782 15.5064 8.11726 15.996 7.96041 16.5079C7.74335 17.2168 7.65022 17.9602 7.68593 18.7029L7.73495 19.7245L6.84009 21.1869",
    stroke: "#228C80",
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2912 14.4911L15.4597 10.9474C15.7293 10.5074 15.5998 9.92577 15.1713 9.64897C14.7427 9.37217 14.1763 9.50518 13.9067 9.94518L11.2445 14.297",
    fill: "#F5FBFA"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2912 14.4911L15.4597 10.9474C15.7293 10.5074 15.5998 9.92577 15.1713 9.64897C14.7427 9.37217 14.1763 9.50518 13.9067 9.94518L11.2445 14.297",
    stroke: "#228C80",
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7123 14.0742L17.5006 11.1516C17.7702 10.7116 17.6406 10.13 17.2121 9.8532C16.7836 9.5764 16.2171 9.7094 15.9475 10.1494L13.4303 14.2647",
    fill: "#F5FBFA"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7123 14.0742L17.5006 11.1516C17.7702 10.7116 17.6406 10.13 17.2121 9.8532C16.7836 9.5764 16.2171 9.7094 15.9475 10.1494L13.4303 14.2647",
    stroke: "#228C80",
    strokeMiterlimit: 10
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8772 15.4403L16.9932 11.9821C17.2432 11.573 17.7536 11.3897 18.1786 11.5967C18.6849 11.8448 18.855 12.4782 18.5658 12.9505L15.4114 18.1069C15.2476 18.3743 15.3183 18.7273 15.5711 18.9071C15.8119 19.0782 16.1389 19.0358 16.3315 18.81L17.1969 17.7927C17.7214 17.1758 18.6415 17.132 19.2191 17.6963C19.4089 17.8811 19.4166 18.1888 19.238 18.3844L16.1326 21.7728C15.4856 22.4788 14.5649 22.852 13.6224 22.7894L12.7457 22.7312L11.7725 24.3215",
    fill: "#F5FBFA"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8772 15.4403L16.9932 11.9821C17.2432 11.573 17.7536 11.3897 18.1786 11.5967C18.6849 11.8448 18.855 12.4782 18.5658 12.9505L15.4114 18.1069C15.2476 18.3743 15.3183 18.7273 15.5711 18.9071C15.8119 19.0782 16.1389 19.0358 16.3315 18.81L17.1969 17.7927C17.7214 17.1758 18.6415 17.132 19.2191 17.6963C19.4089 17.8811 19.4166 18.1888 19.238 18.3844L16.1326 21.7728C15.4856 22.4788 14.5649 22.852 13.6224 22.7894L12.7457 22.7312L11.7725 24.3215",
    stroke: "#228C80",
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcGolpesespalda);
export default __webpack_public_path__ + "static/media/Ic_golpes espalda.aa3730232bcdbca9f920fad7fc5d7f0c.svg";
export { ForwardRef as ReactComponent };